export default __webpack_public_path__ + "static/media/star.7715c633.svg";